export const AUTH = {
  LOGIN: 'v2/auth/login',
  REGISTER: 'v2/auth/register',
  LOGOUT: 'v2/auth/logout',
  VERIFY_EMAIL_OTP: 'v2/auth/email/verify',
  RESEND_EMAIL_OTP: 'v2/auth/email/resend',
  VERIFY_MOBILE_OTP: 'v2/auth/otp/verify',
  REQUEST_OTP_LOGIN: 'v2/auth/otp/request',
  FORGOT_PASSWORD: 'v2/auth/forgot-password',
  RESET_PASSWORD: 'v2/auth/reset-password',
};

export const USER = {
  PROFILE: '/user/profile',
  UPDATE: '/user/update',
  WINNERS: 'v2/users/winners/list',
  LIST: 'v2/users/list',
};

export const REPORT = {
  BIDDERS: 'bidder-report',
  BIDDERS_EXPORT: 'v2/report/bidders',
  TRANSACTIONS_EXPORT: 'v2/report/transactions',
  TRANSACTIONS_NEW_EXPORT: 'v2/transactions/report',
  AUCTION_PAYMENT_BIDDER_EXPORT: 'v2/report/auction-payments/bidders',
  AUCTION_PAYMENT_CLIENT_EXPORT: 'v2/report/auction-payments/clients',
  USERS_EXPORT: 'v2/report/users/export',
};

export const GROUP = {
  LIST: 'v2/groups/list',
};

export const AUCTION = {
  LIST: 'list/auctions',
  ENROLL: 'enroll_user',
  ACKNOWLEDGEMENT_VIEW: (auctionId) => `v2/auctions/${auctionId}/acknowledgement/view`,
  EDIT_INVOICE_DATE: 'v2/auctions/invoice/edit',
};

export const PAYMENT = {
  RECEIPT_SCAN: 'v2/receipt/scan',
  RECHARGE: 'v2/wallet/recharge',
  RECHARGE_APPROVE: 'v2/wallet/recharge/approval',
  AUCTION: 'v2/auction-payment',
};

export const CASH_FLOW = {
  DASHBOARD: 'v2/cash-flow-dashboard',
  ENROLLMENT: 'v2/cash-flow-dashboard/enrollment',
  AUCTION_PAYMENT: 'v2/cash-flow-dashboard/auction-payment',
  AUCTION_PAYMENT_DETAILS: 'v2/cash-flow-dashboard/auction-payment/details',
  CLIENT_PAYOUT_DETAILS: 'v2/cash-flow-dashboard/client-payout/details',
  RECHARGE: 'v2/cash-flow-dashboard/recharge',
  WITHDRAWAL: 'v2/cash-flow-dashboard/withdrawal',
  TRANSACTION: 'v2/cash-flow-dashboard/transactions',
};

export const CLIENT = {
  CLIENTS_LIST: 'v2/organizations/list',
};
export const TRANSACTION = {
  INDEX: 'v2/transactions',
  SUMMARY: 'v2/transactions/summary',
  REQUEST_SUMMARY: 'v2/transactions/request/summary',
  RECHARGE_ACTION: 'v2/transactions/recharge/action',
  WITHDRAWAL_ACTION: 'v2/transactions/withdrawal/action',
};

export const PAYMENT_ACCOUNT = {
  ORGANIZATION_CONFIG: (id) => `v2/payment-bank-account/organizations/${id}/configs`,
  ORGANIZATION_ACCOUNT: (id) => `v2/payment-bank-account/organizations/${id}`,
  CONFIG: 'v2/payment-bank-account/config',
  CONFIG_UPDATE: (id) => `v2/payment-bank-account/config/${id}`,
  LIST: 'v2/payment-bank-account/list',
  INDEX: 'v2/payment-bank-account',
  STORE: 'v2/payment-bank-account',
  UPDATE: (id) => `v2/payment-bank-account/${id}`,
  ACTION: (id) => `v2/payment-bank-account/${id}/action`,
};

export const ORGANIZATION = {
  INDEX: 'v2/organizations',
  STORE: 'v2/organizations',
  UPDATE: (id) => `v2/organizations/${id}`,
  DELETE: (id) => `v2/organizations/${id}`,
  // ACTION: (id) => `v2/organizations/${id}/action`,
};

export const ENROLLMENT = {
  INDEX: 'v2/enrollments',
  // STORE: 'v2/enrollments',
  // UPDATE: (id) => `v2/enrollments/${id}`,
  // DELETE: (id) => `v2/enrollments/${id}`,
  ACTION: 'v2/enrollments/action',
  TRANSACTIONS_NEW_EXPORT :  'v2/enrollments/report',
};

export const ENROLLMENT_REFUND = {
  INDEX: 'v2/enrollments/refunds',
  ACTION: 'v2/enrollments/refunds/action',
  ACTION_BULK: 'v2/enrollments/refunds/action/bulk',
};

export const DASHBOARD = {
  CLIENT_MANAGEMENT: 'v2/client/management',
};

export const TABLE_PREFERENCE = {
  SHOW: (tableKey) => `v2/table-preferences/${tableKey}`,
  UPDATE: (tableKey) => `v2/table-preferences/${tableKey}`,
};
